import { RootStore } from './index';
import { EventType } from '@src/dtos/analytics.dto';
import analyticsService from '../../services/analytics.service';
export class BaseStore {
  protected rootStore: RootStore;

  // reset data store (mainly when change customer)
  reset() {
    return;
  }

  protected sendEvent(eventType: EventType, extraInfo?: any) {
    const serviceData = this.rootStore.customerStore.isSingleConnection ?
      this.rootStore.customerStore.selectedCustomer?.services[0] : this.rootStore.customerStore.selectedLocation;
    analyticsService.sendEvent(eventType,
      this.rootStore.userStore.data,
      this.rootStore.customerStore.selectedCustomer,
      serviceData,
      extraInfo);
  }

  public sendGeneralEvent(eventType: EventType, extraInfo?: any) {
    this.sendEvent(eventType, extraInfo);
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }
}
